import React from 'react';
import PropTypes from 'prop-types';
import {Header} from '../../../Header';
import {Modal, Button} from '@learningblocks/shared-components';
import {Content} from './Contents';

import cname from '../style.module.scss';
import './style.scss';

/**
 * SpectrophotometerConfigModal
 *  - The modal window where we can set reference absorbance value
 *    and then view the relative absorbance values
 */
export function SpectrophotometerConfigModal(props) {

  const saveAbsorbanceValuesAndClose = () => {
    props.absorbanceTable.data.forEach((row, rowIndex) => {
      row.forEach((cell, cellIndex) => {
        if(cell.hasOwnProperty('linkedField')){
          if(cell.value !== null && !isNaN(cell.value)){
            props.questionTableCellUpdateResults({
              id: (cell.linkedField.rowId - 1) + "_" + (cell.linkedField.cellId - 1),
              value: cell.value,
              answer: [5.9, 8.1]
            })
          }
        }
      })
    })

    props.onClose()
  }

  return (
    <Modal
      isOpen={props.isOpen}
      closeButton={true}
      close={saveAbsorbanceValuesAndClose}
      notebookExpanded={!props.notebookCollapsed}
      className={`${cname.configModal} spectrophotometer_configModal`}>
      <Header
        className={cname.header}
        label='SPECTROPHOTOMETER SETTINGS'
        size={props.size}
      />
      <div className={cname.section}>
        <Content
          poweredUp={props.poweredUp}
          wavelength={props.wavelength}
          setWavelength={props.setWavelength}
          absorbanceValue={props.absorbanceValue}
          onClickZeroButton={props.onClickZeroButton}
          relativeAbsorbance={props.relativeAbsorbance}
          onClickPowerButton={props.onClickPowerButton}
          cuvetteId={props.cuvetteId}
          absorbanceTableCellUpdate={props.absorbanceTableCellUpdate}
          absorbanceTable={props.absorbanceTable}
        />
      </div>
      <div className={cname.footer}>
        <Button onClick={saveAbsorbanceValuesAndClose}>Done</Button>
      </div>
    </Modal>
  );
}

SpectrophotometerConfigModal.propTypes = {
  /**
   * Boolen to set if popup is open
   */
  isOpen: PropTypes.bool,
  /**
   * Callback to close Modal window
   */
  onClose: PropTypes.func,
  /**
   * Absorbance value of solution inside the cuvette
   */
  absorbanceValue: PropTypes.number,
  /**
   * Relative absorbance value set
   */
  relativeAbsorbance: PropTypes.number,
  /**
   * Callback for PowerButton click
   */
  onClickPowerButton: PropTypes.func,
  /**
   * Callback for ZeroButton click
   */
  onClickZeroButton: PropTypes.func,
  /**
   * Current wavelenght
   */
  wavelength: PropTypes.number,
  /**
   * Callback function to set wavelength value
   */
  setWavelength: PropTypes.func,
  /**
   * Boolean to set if spectrophotometer is on/off
   */
  poweredUp: PropTypes.bool,
};

SpectrophotometerConfigModal.defaultProps = {
  size: 'lg',
  isOpen: false,
};
